import {usePage} from "@inertiajs/react";

export function mix(name) {
    // nameが/で始まっていない場合は/を付与する
    if (name.charAt(0) !== '/') {
        name = '/' + name;
    }

    const { mixManifest } = usePage().props;
    return mixManifest[name];
}
